import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { addMonths, format, parseISO } from 'date-fns';
import Header from './Header';
import Footer from './Footer';

function TermsService() {
  
  
  return (

    <div className="container mx-auto">
      <Header></Header>
      <div class="p-10 text-sm/7">
  <div class="space-y-6 p-4">
    <p class="font-bold">Terms of Service for MemberMeld - A Complete Member & Membership management solution at Your Fingertips</p>
    <p><span class="font-bold">Last updated:</span> June 1st, 2025</p>

    <div>
      <p>Welcome to MemberMeld ("MemberMeld", "we," "our," or "us"). MemberMeld is a product owned and operated by Reyspire Digital Software Private Limited, a registered business in India.</p>
      </div>
     <div>
     <p>These Terms and Conditions govern your use of the MemberMeld mobile Application and other related services.</p>
    <p>Your access to or use of MemberMeld signifies your acceptance of these Terms. If you do not agree to them, please refrain from using our services.</p>
    <p>If you have any questions, you can contact us at <a href="mailto:support@membermeld.com" target="_blank" rel="noopener noreferrer" className="text-[#00A6FB] hover:text-red-500">support@membermeld.com</a></p>
    </div>

    <div>
      <p class="font-bold">1. Definitions</p>
      <p>•	Application: Refers to the Member and Membership Management Application (MemberMeld), including all related services and features.</p>
      <p>•	User: Any individual or entity accessing or using the Application.</p>
    </div>
    <div>
      <p class="font-bold">2. Account and Subscription Guidelines</p>
      <p>•	To use the application, you will need to create an account via email and password, Google Sign-In, or Apple Sign-In.</p>
      <p>•	Users are responsible for maintaining the confidentiality of their account credentials.</p>
      <p>•	Account Suspension and Termination:
We reserve the right to suspend or terminate your access to the service at any time, without prior notice, if you violate these terms. If your account is terminated, your access to the service will end immediately.</p>
      <p>•	Unauthorized access or use of another user’s account is strictly prohibited.</p>
    </div>
    
    <div>
      <p class="font-bold">3. Member data Management</p>
      <p>•	Users agree to keep their data accurate for correct results.</p>
      <p>•	The Application is not responsible for any mismanagement of member’s data by users.</p>
    </div>

    <div>
      <p class="font-bold">4. Payment and Billing</p>
      <p>•	We do not store or process payment details, all financial transactions are securely managed by <span class="font-bold">Razorpay</span>, in accordance with their respective privacy and security policies <a href="https://razorpay.com/privacy" target="_blank" className="text-[#00A6FB] hover:text-red-500" rel="noopener noreferrer">Privacy Policy </a> &
          <a href="https://razorpay.com/terms" target="_blank" className="text-[#00A6FB] hover:text-red-500" rel="noopener noreferrer"> Terms and Conditions.</a></p>
      <p><span class="font-bold">•	No refunds: </span>All purchases are final.</p>
    </div>

    <div>
      <p class="font-bold">5. Renewal and Cancellation</p>
      <p>•	All subscription activities—including activation, renewal —are managed through the MemberMeld.</p>
      <p>•	For any subscription related query please contact us at <a href="mailto:support@membermeld.com" target="_blank" rel="noopener noreferrer" className="text-[#00A6FB] hover:text-red-500">support@membermeld.com</a></p>
    </div>

    <div>
      <p class="font-bold">6. Liability & Disclaimers</p>
      <p>•	MemberMeld is not responsible for the content, privacy policies, or practices of any third-party websites or services that may be linked or referenced within the app.</p>
      <p>•	In the event of errors, downtime, or data loss, users are advised to wait for resolution through backend maintenance or updates released via the App Store or Google Play.</p>
    </div>

    <div>
      <p class="font-bold">7. Data Privacy and Security</p>
      <p>•	We prioritize data security and implement reasonable measures to protect user information.</p>
      <p>•	Users are responsible for safeguarding their credentials and personal data.</p>
      <p>•	For more details, refer to our <a href="https://membermeld.com/privacy" target="_blank" className="text-[#00A6FB] hover:text-red-500" rel="noopener noreferrer">Privacy Policy.</a></p>
    </div>

    <div>
      <p class="font-bold">8. Restrictions on Use</p>
      <p>Users shall not:</p>
      <p>•	Engage in unauthorized access, distribution, or modification of the Application’s data.</p>
      <p>•	Use the Application for unlawful activities.</p>
      <p>•	Violate any applicable local, state, or international laws while using the Application.</p>
    </div>

    <div>
      <p class="font-bold">9. Modifications to Terms</p>
      <p>•	We reserve the right to modify these Terms and Conditions at any time.</p>
      <p>•	Continued use of the Application after modifications constitutes acceptance of the new Terms.</p>
    </div>

    <div>
      <p class="font-bold">10. Content</p>
      <p>•	MemberMeld owns all content in the app, including logos, design, and features.</p>
    </div>

    <div>
      <p class="font-bold">11. Contact Information & Updates</p>
      <p>•	Updates to these Terms will be posted on <a href="https://membermeld.com/tos" target="_blank" className="text-[#00A6FB] hover:text-red-500" rel="noopener noreferrer">https://membermeld.com/tos</a></p>
      <p>•	For any questions regarding these Terms and Conditions, please contact us at </p>
      <p><span className="font-bold">Email: </span><a href="mailto:support@membermeld.com" target="_blank" rel="noopener noreferrer" className="text-[#00A6FB] hover:text-red-500">support@membermeld.com</a></p>
      <p><span className="font-bold">Website: </span><a href="https://membermeld.com" target="_blank" rel="noopener noreferrer" className="text-[#00A6FB] hover:text-red-500">https://membermeld.com</a></p>
    </div>


  </div>
</div>

      <Footer></Footer>
      </div>
  );
  
}

export default TermsService;
